var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83 3.604c-.096.048-.19.1-.283.155l-.51-.86a5.834 5.834 0 018.056 7.883l-.871-.49A4.834 4.834 0 005.83 3.604zM3.797 5.547a4.834 4.834 0 006.677 6.529l.51.86a5.834 5.834 0 01-8.059-7.878l.872.489z",
    fill: "#3C3F47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.619 11.22l-2.074-2.073.707-.707 2.019 2.007-.171.306a1 1 0 01-.274.313l-.207.155zM4.893 7.269L2.84 5.209l.112-.186c.058-.095.127-.184.206-.262l.322-.318L5.6 6.562l-.707.707z",
    fill: "#3C3F47"
  })));
}
export default __webpack_public_path__ + "static/mail_refresh.2116ed07.svg";
export { SvgMailRefresh as ReactComponent };